 "use strict";
 /*oneimage指令:
    html:<div>
      <trs-single-img></trs-single-img>
    </div>,
    css:.oneImage_popup_fa,.oneImage_son,.oneImage_popup_content等，处于oneImage.css样式表内，
    js:效果为替代单个图片组件的的主要页面结构*/
 angular.module("pieceMgr.singleImgdir", ["pieceMgr.dateTimepicker", "pieceMgr.imgUpload"])
     .directive('trsSingleImg', ['$modal', '$timeout', 'fragmentService', "trsSelectDocumentService", "$filter", "editPictureService", function($modal, $timeout, fragmentService, trsSelectDocumentService, $filter, editPictureService) {
         return {
             restrict: 'E',
             replace: true,
             transclude: true,
             scope: {
                 jsonObj: "=",
                 singleImageForm: "=",
                 widgetParams: "=",
                 index: "@",
                 required: "@"
             },
             templateUrl: './editingCenter/website/fragmentManagement/singleImage/singleImage.html',
             controller: function($scope, $element, $http) {

             },
             link: function(scope, element, attr) {
                 init();
                 scope.nowTime = fragmentService.getNowTime();
                 if (angular.isDefined(scope.jsonObj)) {
                     scope.item = scope.jsonObj;
                     scope.uploaderSrc = scope.item.imgsrc;
                     if (typeof scope.item.reltime == 'object') {
                         scope.item.reltime = $filter('date')(scope.item.reltime, "yyyy-MM-dd HH:mm").toString()
                     } else if (typeof scope.item.reltime === "string" && scope.item.reltime.indexOf("T") > -1) {
                         scope.item.reltime = scope.item.reltime.replace("T", " ").split(":").splice(0, 2).join(":");
                     }
                 } else {
                     scope.item = {
                         title: "",
                         imgsrc: "",
                         imgName: ""
                     };
                 }
                 $timeout(function() {
                     scope.callBack = {
                         success: function(file, src) {
                             $timeout(function() {
                                 scope.item.imgsrc = src.imgSrc;
                                 scope.item.imgName = src.imgName;
                                 scope.uploaderSrc = src.imgSrc;
                                 if (scope.percentage === 100) {
                                     scope.uploaderSuccess = true;
                                     scope.item.extField1 = "";
                                 }
                             });
                         },
                         error: function(file) {},
                         file: function(file, uploader) {
                             $timeout(function() {
                                 scope.uploaderSuccess = false;
                                 scope.uploadFileName = file.name;
                                 uploader.upload();
                             });
                         },
                         tar: function(file, percentage) {
                             scope.percentage = percentage * 100;
                         },
                         comp: function() {

                         },
                         start: function() {

                         },
                         finish: function() {

                         }
                     };
                 });
                 scope.showConSelModal = function() {
                     var relNewsData = [];
                     if (angular.isDefined(scope.item.recid)) {
                         relNewsData.push({
                             TITLE: scope.item.title,
                             HOMETITLE: scope.item.subtitle,
                             TITLECOLOR: scope.item.titlecolor,
                             ABSTRACT: scope.item.abstract,
                             DOCPUBURL: scope.item.url,
                             RECID: scope.item.recid,
                             RELTIME: scope.item.reltime,
                             SOURCE: scope.item.source,
                             AUTHOR: scope.item.author,
                             METADATAID: scope.item.metadataId,
                         });
                     }
                     scope.widgetParams.relNewsData = relNewsData;
                     scope.widgetParams.IsPicDoc = true;
                     scope.widgetParams.platform = 1;
                     trsSelectDocumentService.trsSelectDocument(scope.widgetParams, function(result) {
                         scope.item.title = result[0].title;
                         scope.item.subtitle = result[0].subtitle;
                         scope.item.titlecolor = result[0].titlecolor;
                         scope.item.abstract = result[0].abstract;
                         scope.item.url = result[0].url;
                         scope.item.recid = result[0].recid;
                         scope.item.metadataId = result[0].metadataId;
                         scope.item.docId = result[0].metadataId;
                         scope.item.reltime = result[0].reltime;
                         scope.item.imgsrc = result[0].imgsrc;
                         scope.item.imgName = result[0].imgName;
                         scope.item.source = angular.isDefined(result[0].source) ? result[0].source : "";
                         scope.item.author = angular.isDefined(result[0].author) ? result[0].author : "";
                     });
                 };
                 scope.changeTime = function(time) {
                     time = $filter('date')(time, "yyyy-MM-dd HH:mm").toString();
                     return time;
                 };
                 scope.$watch('item.reltime', function(newV, oldV) {
                     if (newV != oldV) {
                         if (typeof newV == 'object') {
                             scope.item.reltime = $filter('date')(scope.item.reltime, "yyyy-MM-dd HH:mm").toString()
                         } else if (newV.indexOf("T") > -1) {
                             scope.item.reltime = newV.replace("T", " ").split(":").splice(0, 2).join(":");
                         }
                     }
                 });
                 scope.modifyImg = function() {
                     var imgObj = {
                         PERPICURL: scope.item.imgsrc,
                         APPFILE: scope.item.imgName,
                         APPDESC: ""
                     };
                     editPictureService.editPicture(imgObj, scope.widgetParams.siteid, function(img) {
                         scope.item.imgName = img.imgName;
                         scope.uploaderSrc = scope.item.imgsrc = img.imgSrc;
                     });
                 };
                 /**
                  * [cleanIput description] 删除标题
                  * @return {[type]} [description]
                  */
                 scope.cleanIput = function(item, index) {
                     item.title = "";
                     document.getElementsByName('title_' + index + '_image')[0].focus();
                 };

                 function init() {
                     scope.requiredObj = {};
                     scope.status = {
                         sharedDate: ''
                     };
                     for (var i = 0; i < scope.required.split(",").length; i++) {
                         scope.requiredObj[scope.required.split(",")[i].replace(/ /g, "")] = true;
                     }
                 }
             }
         };
     }]);